import React, { useContext } from 'react'
import { Alert, Box, Button, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { useTranslation } from 'react-i18next';
import { PageNames, PageContext } from '../Home/HomeTopMailConfirm';
import { HeldTimesContext } from '../Root/CompetitionRoot';

/**
 * 未登録画面
 * 情報確認のログイン情報でデータが登録されていない場合に表示する
 */
export function KaguRefNotReg() {

    const [t] = useTranslation();

    const {setPage} = useContext(PageContext);

    const heldTimesOption = useContext(HeldTimesContext);

    return(
        <>
            <Box>
                <Typography 
                    variant='h4'
                    sx={{
                        textAlign:"left",
                        mt:1
                    }}
                >
                    {t("KaguRefNotReg.Title", heldTimesOption)}<br/>
                </Typography>   
                <Alert icon={false} severity="error"
                    sx={{
                        mt:1,
                        textAlign:"left"
                    }}
                >
                    {t("KaguRefNotReg.Text1", heldTimesOption)}                    
                </Alert>
                <Grid2 container spacing={1} mt={1}>
                    <Grid2>
                        <Button variant="outlined" onClick={() => setPage(PageNames.KaguRefForm)}>{t("Common.Back")}</Button>
                    </Grid2>
                </Grid2>
            </Box>  
        </>
    );

}